<template>
  <div class="text-left">
    <b-overlay
      :show="myDelegations === null"
      opacity="0.8"
      spinner-small
      spinner-variant="dark"
    >
      <div class="bg-card">
        <h2 class="mb-3">
          {{
            $t(
              'pages.delegations.title',
              'All my candidate delegations and offers ({count})',
              { count: myDelegations && myDelegations.length ? myDelegations.length : 0 }
            )
          }}
        </h2>
        <div v-if="myDelegations && myDelegations.length === 0">
          {{ $t('pages.delegations.no-delegations', 'No delegations yet...') }}
        </div>
        <div
          v-for="offerApply in myDelegations"
          :key="offerApply.id"
        >
          <OfferCandidateCard
            :candidate="offerApply"
            :is-delegation="true"
            @cancelDelegation="cancelDelegation"
          />
        </div>
      </div>
    </b-overlay>

    <!-- Delete offer modal -->
    <b-modal
      v-model="cancelDelegationModal"
      :title="$t('modals.delete.confirm', 'Are you sure you want to delete?')"
      header-bg-variant="danger"
      header-text-variant="light"
      centered
      size="md"
      @ok="destroy(cancelOfferApplyId)"
    >
      {{ $t('modals.irrecoverable-action', 'You will not be able to recover it later!') }}
    </b-modal>
  </div>
</template>

<script>
import OfferCandidateCard from '@/components/jobs/blocks/offerCandidateCard';

export default {
  components: {
    OfferCandidateCard
  },
  data() {
    return {
      myDelegations: null,
      cancelDelegationModal: false,
      cancelOfferApplyId: null
    }
  },
  mounted() {
    this.getMyDelegations();
  },
  methods: {
    getMyDelegations() {
      this.axios.get('/hr/my-delegations')
        .then( response => {
          this.myDelegations = response.data;
        })
        .catch();
    },
    cancelDelegation(offerApplyId) {
      this.cancelDelegationModal = true;
      this.cancelOfferApplyId = offerApplyId;
    },
    destroy(offerApplyId) {
      this.cancelDelegationModal = false;
      this.axios.delete('/offerApply/cancel-delegation/' + offerApplyId)
        .then( () => {
          this.getMyDelegations();
          this.$toastNotification('success', '', this.$t('modals.delete.success', 'Deleted successfully'));
        })
        .catch( (error) => {
          this.$toastNotification('danger', '', error.response.data.error);
        });
    }
  }
}
</script>
